module.exports = new __parcel__URL__("Planet_B_teaser_ja.676098f9.webp").toString();